module.exports = __webpack_public_path__ + "static/media/FO.76d76579.svg";